import React from 'react';
import { RouteProps, Redirect, Route } from 'react-router-dom';
import PageLayout from '../layouts/pageLayout';
import * as storageService from '../services/localStorageService';
import { areAllConfigFilesReady } from '../services/apiParticulierService';
import * as path from './paths';
import { redirectToHomeLogin } from './homeRouting';

interface IPrivateRoute extends RouteProps {
    providers?: any[];
    name?: string | undefined;
    step?: number | undefined;
}

const PrivateRoute: React.FC<IPrivateRoute> = ({ component: Component, providers, ...rest }) => {
    /**
     * Vérification si utilisateur identifié avec cookie
     */
    const agent = storageService.getCurrentAgent();
    if (!agent) {
        redirectToHomeLogin();
    }

    /**
     * Vérification si les fichiers de conf sont ok. sinon, force le login qui les re-télécharge.
     */
    if (!areAllConfigFilesReady()) {
        redirectToHomeLogin();
    }

    /**
     * Vérification si l'étape global est inférieure à l'étape demandée sinon redirection
     */
    if (rest.step && rest.step !== 8) {
        if (storageService.getAuditCurrentStep() < rest.step) {
            return <Redirect to={path.ROUTE_AUDIT} />;
        }
    }

    let CustomRoute = <Route component={Component} {...rest} />;
    if (providers) {
        CustomRoute = providers.reduce((acc: any, Provider: any) => {
            return <Provider>{acc}</Provider>;
        }, <Route component={Component} {...rest} />);
    }

    return <PageLayout>{CustomRoute}</PageLayout>;
};

export default PrivateRoute;
